import type { Stroke } from '../types/app.js';
import type { SchemaInput } from './schema-input.js';
import { isString } from './runtime-values.js';

export function applyMarkerDetails(target: Pick<Stroke, 'tool' | 'markerAddress' | 'markerNote'>, address: SchemaInput, note: SchemaInput): void {
  if (target.tool !== 'marker') return;
  if (isString(address)) target.markerAddress = address.trim().slice(0, 500);
  if (isString(note)) target.markerNote = note.trim().slice(0, 1000);
}

interface EncodedMarkerDetails { ma?: string; mn?: string }

export function encodeMarkerDetails(stroke: Pick<Stroke, 'tool' | 'markerAddress' | 'markerNote'>): EncodedMarkerDetails {
  const result: EncodedMarkerDetails = {};
  if (stroke.tool !== 'marker') return result;
  if (stroke.markerAddress) result.ma = stroke.markerAddress;
  if (stroke.markerNote) result.mn = stroke.markerNote;
  return result;
}
